import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CookieConsent, { getCookieConsentValue } from 'react-cookie-consent';
import { isAppPath, isFramedPath } from '../../lib/embedRoute';

// Barra de cookies de toda la web (antes solo estaba en la home y solo tenía «Aceptar»).
// Mismo nombre de cookie que la barra anterior, para respetar lo que cada visitante ya eligió.
// «Aceptar» inicia Google Analytics (App.js); «Rechazar» deja solo las cookies técnicas.
export const CONSENT_COOKIE = 'myAwesomeCookieName2';

export const hasAnalyticsConsent = () => {
   try {
      return getCookieConsentValue(CONSENT_COOKIE) === 'true';
   } catch (e) {
      return false;
   }
};

const CookieBanner = ({ onAccept }) => {
   const { t } = useTranslation();
   const { pathname } = useLocation();
   // Las demos y los embebidos viven dentro de webs de terceros: allí no hay barra ni Analytics.
   if (pathname.startsWith('/playbook-demo') || isFramedPath(pathname) || isAppPath(pathname)) return null;

   return (
      <CookieConsent
         location="bottom"
         cookieName={CONSENT_COOKIE}
         expires={150}
         enableDeclineButton
         flipButtons
         buttonText={t('cookies_button')}
         declineButtonText={t('cookies_decline')}
         onAccept={onAccept}
         style={{
            background: '#1f1841',
            color: '#fff',
            alignItems: 'center',
            padding: '10px 16px',
            fontSize: '14px',
            lineHeight: 1.4,
            maxHeight: '40vh',
            overflowY: 'auto',
         }}
         buttonStyle={{
            background: '#6a60f0',
            color: '#fff',
            fontSize: '15px',
            fontWeight: 700,
            borderRadius: '8px',
            padding: '10px 22px',
            margin: '8px 15px',
         }}
         declineButtonStyle={{
            background: 'transparent',
            color: '#fff',
            border: '1px solid #fff',
            fontSize: '15px',
            fontWeight: 700,
            borderRadius: '8px',
            padding: '9px 22px',
            margin: '8px 0 8px 15px',
         }}
      >
         {t('cookies_text_short')}{' '}
         <Link to="/cookies-policies" style={{ color: '#fff', textDecoration: 'underline' }}>{t('cookies_policy_link')}</Link>
      </CookieConsent>
   );
};

export default CookieBanner;
